import { createContext, useContext } from 'react';

interface ListNavigationContextValue {
    enabled: boolean;
    /**
     * When true, HBActionArea inside items is hidden from the tab order
     * (tabIndex=-1). Set by HBList when `disableKeyboardNavigation=true` so
     * that external focus managers (e.g. Radix DropdownMenu) own tabindex
     * management without HBActionArea polluting the tab sequence.
     */
    suppressItemTabStop: boolean;
}

export const ListNavigationContext = createContext<ListNavigationContextValue>({
    enabled: false,
    suppressItemTabStop: false
});

export const useListNavigationContext = () => useContext(ListNavigationContext);
